"use strict";
exports.__esModule = true;
exports.generateNewMarker = exports.getFootnoteId = void 0;
var utilities_1 = require("@sportnet/utilities");
exports.getFootnoteId = function (elementId, marker) {
    return "-" + elementId + "-" + utilities_1.slugify(marker);
};
/**
 * Finds biggest number in footnotes markers and increments it to
 * generate marker for new footnote in list.
 *
 * @param footnotes
 */
exports.generateNewMarker = function (footnotes) {
    var maxNumber = (footnotes || []).reduce(function (acc, footnote) {
        var num = Number(footnote.marker);
        if (!isNaN(num)) {
            if (num > acc) {
                return num;
            }
        }
        return acc;
    }, 0);
    return String(maxNumber + 1);
};
